module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.818 12L.658 3.84A2.25 2.25 0 0 1 3.842.66L12 8.817l8.16-8.16a2.25 2.25 0 0 1 3.18 3.183L15.183 12l8.16 8.16a2.25 2.25 0 0 1-3.183 3.18L12 15.183l-8.16 8.16a2.25 2.25 0 0 1-3.18-3.183L8.817 12z\" fill=\"#000\" opacity=\".2\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/icons/times-icon-gray.svg
// module id = wKHa
// module chunks = 89